import { createTag } from '@frontend/api-client/utils';
import { camelCaseApiResponse } from '@frontend/api-client/utils/transformers';
import type { BaseApi } from '@frontend/api-client/utils/types';
import type {
  ClaimLowCreditBonusResponse,
  FullLedgerReportPayload,
  FullLedgerReportResponse,
  RetrieveCreditsResponse,
  RetrieveHouseholdResponse,
} from '@frontend/api-types';
import { convertObjectKeysCase } from '@frontend/duck-tape';
import { HOUSEHOLD_ENDPOINTS } from './endpoints';

export const getHouseholdApi = (baseApi: BaseApi) =>
  baseApi.injectEndpoints({
    endpoints: (builder) => ({
      claimLowCreditBonus: builder.mutation<ClaimLowCreditBonusResponse, void>({
        invalidatesTags: [createTag('Credit'), createTag('Client')],
        query: () => ({
          method: 'POST',
          url: HOUSEHOLD_ENDPOINTS.claimLowCreditBonus(),
        }),
        transformResponse: (response: GenericRecord) =>
          convertObjectKeysCase(response, 'camelCase') as ClaimLowCreditBonusResponse,
      }),
      removeMemberFromHousehold: builder.mutation<void, { clientId: string; householdId: string }>({
        invalidatesTags: () => [createTag('Household')],
        query: ({ clientId, householdId }) => ({
          method: 'PATCH',
          url: HOUSEHOLD_ENDPOINTS.removeMemberFromHousehold(householdId, clientId),
        }),
      }),
      retrieveCredits: builder.query<RetrieveCreditsResponse, void>({
        providesTags: [createTag('Credit')],
        query: HOUSEHOLD_ENDPOINTS.retrieveCredits,
        transformResponse: (response: GenericRecord) =>
          convertObjectKeysCase(response, 'camelCase') as RetrieveCreditsResponse,
      }),
      retrieveFullLedgerReport: builder.query<FullLedgerReportResponse, FullLedgerReportPayload>({
        query: (params) => ({
          url: HOUSEHOLD_ENDPOINTS.retrieveFullLedgerReport(params),
        }),
        transformResponse: camelCaseApiResponse<FullLedgerReportResponse>,
      }),
      retrieveHousehold: builder.query<RetrieveHouseholdResponse, string>({
        providesTags: () => [createTag('Household')],
        query: (id) => HOUSEHOLD_ENDPOINTS.retrieveHousehold(id),
        transformResponse: (response: GenericRecord) =>
          convertObjectKeysCase(response, 'camelCase') as RetrieveHouseholdResponse,
      }),
    }),
    overrideExisting: true,
  });
